import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-secondary-100/80 text-foreground-900">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-2-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl text-foreground-950">
                漫选<span className="text-primary-500">社</span>
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-700">
              专注漫画软件应用排行、评测与推荐的内容平台。收录漫画软件应用大全与合集，帮你快速锁定好用的漫画软件应用，解决找漫画、追更、看热门作品的需求。
            </p>
            <div className="mt-5 flex items-center gap-3 text-foreground-600">
              <a href="#" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line" aria-hidden="true"></i>
              </a>
              <a href="#" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50" aria-label="微信公众号" rel="nofollow">
                <i className="ri-wechat-line" aria-hidden="true"></i>
              </a>
              <a href="#" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50" aria-label="哔哩哔哩" rel="nofollow">
                <i className="ri-bilibili-line" aria-hidden="true"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-bold text-foreground-950">快速导航</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-700">
              <li><Link to="/" className="transition-colors hover:text-primary-600">首页</Link></li>
              <li><Link to="/rankings" className="transition-colors hover:text-primary-600">漫画软件应用排行</Link></li>
              <li><Link to="/reviews" className="transition-colors hover:text-primary-600">评测推荐</Link></li>
              <li><Link to="/faq" className="transition-colors hover:text-primary-600">常见问题</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-foreground-950">更多内容</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-700">
              <li><Link to="/about" className="transition-colors hover:text-primary-600">关于我们</Link></li>
              <li><Link to="/contact" className="transition-colors hover:text-primary-600">联系我们</Link></li>
              <li><Link to="/reviews/rank-2026" className="transition-colors hover:text-primary-600">2026排行盘点</Link></li>
              <li><Link to="/reviews/free-apps" className="transition-colors hover:text-primary-600">免费应用推荐</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-foreground-200 pt-6 text-sm text-foreground-600 sm:flex-row">
          <p>© 2026 漫选社 · 漫画软件应用排行大全</p>
          <p className="text-foreground-500">让每一部好漫画都不被错过</p>
        </div>
      </div>
    </footer>
  );
}